import React from 'react';
import { translate } from '@utils/i18n';
import { namespace } from './constants';
import { editTerritoryPath } from '../../../routes';
const getColumnsDefinition = () => [
    {
        label: translate('headers.name', { namespace }),
        dataKey: 'name'
    },
    {
        label: translate('headers.details', { namespace }),
        dataKey: 'customFields',
        renderer: ({ item }) => (React.createElement("span", { className: "territories-settings__details" }, item.customFields.map(({ name, value }, index) => (React.createElement(React.Fragment, { key: name },
            index > 0 && ' · ',
            React.createElement("strong", null,
                name,
                ":"),
            " ",
            value)))))
    },
    {
        label: '',
        dataKey: 'id',
        width: '100px',
        renderer: ({ item }) => (React.createElement("a", { href: editTerritoryPath(item.id), className: "qmb-control--icon", title: translate('edit', { namespace: 'generic' }) },
            React.createElement("i", { className: "fa-light fa-pencil", "aria-hidden": "true" })))
    }
];
export default getColumnsDefinition;
